export default __webpack_public_path__ + "static/media/intIconFi.abfce99a.PNG";